import React from 'react';
import { useSelector } from 'react-redux';
import { icons } from 'images';
import SVG from 'images/svg/SVG.js';

export const RecordBeingViewedInitials = ({ id, color, invert }) => {
  const userId = useSelector((state) => state.user.id);
  const recordsSet = useSelector((state) => state.ui.viewingRecord);
  const record = (recordsSet || []).find((n) => n.id === id);
  if (record && (record || {}).userId !== userId) {
    const message = `Being viewed by ${record.initials}`;
    return <SVG icon={'Eye'} title={message} invert={invert} />;
  }
  return null;
};
